export default __webpack_public_path__ + "static/media/ars.f0908417.JPG";